import { render, staticRenderFns } from "./AvisoSelf.vue?vue&type=template&id=4324d312&scoped=true&"
import script from "./AvisoSelf.vue?vue&type=script&lang=js&"
export * from "./AvisoSelf.vue?vue&type=script&lang=js&"
import style0 from "./AvisoSelf.vue?vue&type=style&index=0&id=4324d312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4324d312",
  null
  
)

export default component.exports